import SectionHeading from "@/pages/home/components/SectionHeading";
import { quickFacts } from "@/mocks/homeContent";

export default function QuickFacts() {
  return (
    <section id="overview" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="作品速览"
          title="一张表看懂这个主题"
          desc="先把最基础的信息集中列出，方便初次接触「善良的女秘书」的观众在几秒内建立整体印象，再决定深入阅读哪些分区。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {quickFacts.map((fact) => (
            <div
              key={fact.label}
              className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700">
                <i className={fact.icon}></i>
              </span>
              <div className="min-w-0">
                <p className="text-xs text-foreground-500">{fact.label}</p>
                <p className="mt-1 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                  {fact.value}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}